import { NavLink } from 'react-router-dom';
import { SelectListPosition } from '../select/types';
import IconArrowRight from '../icons/arrow-right';
import IconLoader from '../icons/loader';
import { OptionListTypes } from './types';

import styles from './application-selector.module.css';

export default function OptionList({
  onButtonClick,
  listPosition,
  setListVisible,
  list,
  setSearchValue,
  isLoading,
  onApplicationClick,
  ulRef,
  onScroll,
  withoutButton,
}: OptionListTypes) {
  return (
    <ul
      className={`${styles.optionList} ${
        listPosition === SelectListPosition.TOP
          ? styles.optionListTop
          : styles.optionListBottom
      } ${isLoading ? styles.optionListOverflowHidden : ''}`}
      ref={ulRef}
      onScroll={onScroll}
    >
      {!withoutButton && (
        <li className={styles.addButtonWrapper}>
          <button
            type="button"
            className={styles.addButton}
            onClick={() => {
              onButtonClick();
              setListVisible(false);
            }}
            tabIndex={-1}
          >
            <div className={styles.textWrapper}>+ Create new customer</div>
          </button>
        </li>
      )}

      {isLoading && (
        <li className={styles.listLoader}>
          <IconLoader />
        </li>
      )}
      {!list?.length && (
        <li className={styles.emptyList}>No such customers found</li>
      )}
      {!isLoading &&
        list &&
        list.length > 0 &&
        list.map((item) => {
          let link;

          if (item.type === 'INDIVIDUAL' && !item.organizationId) {
            link = `/customers/new-application/individual/${item.id}`;
          } else if (item.type === 'CORPORATE' && !item.organizationId) {
            link = `/customers/new-application/corporate/${item.id}`;
          } else if (
            !item.organizationId &&
            (item.type === 'COMPANY_OFFICIAL' ||
              item.type === 'MAIN_REPRESENTATIVE')
          ) {
            link = `/customers/new-application/company-official/${item.id}`;
          } else if (
            item.organizationId &&
            (item.type === 'INDIVIDUAL' ||
              item.type === 'COMPANY_OFFICIAL' ||
              item.type === 'MAIN_REPRESENTATIVE')
          ) {
            link = `/customers/individual/${item.organizationId}`;
          } else if (item.organizationId && item.type === 'CORPORATE') {
            link = `/customers/corporate/${item.organizationId}`;
          }

          return (
            <li key={item.id}>
              <button
                type="button"
                onClick={() => {
                  setSearchValue(item.name);
                  setListVisible(false);
                  onApplicationClick(item.id);
                }}
                tabIndex={-1}
              >
                <div className={styles.applicationNameWrapper}>
                  <div className={styles.applicationName}>{item.name}</div>
                </div>
                <div className={styles.applicationDob}>{item.dob}</div>
              </button>
              <NavLink
                type="button"
                to={link as string}
                className={styles.applicationLink}
                target="_blank"
                tabIndex={-1}
              >
                {!item.organizationId ? 'Go to Application' : 'Go to Customer'}
                <IconArrowRight />
              </NavLink>
            </li>
          );
        })}
    </ul>
  );
}
